export enum CrmSubmissionStatus {
  NoChange = 0,
  RevalidationRecordRequired = 981360000,
  PartialRecordReceived = 981360002,
  FullRecordReceived = 981360001,
}